import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION16: PdfComponent = {
  type: 'section',
  id: 's16',
  title: '16. Data Protection and Security',
  content: [
    {
      type: 'bulletList',
      id: 's16bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Each party shall comply with its respective obligations, and may exercise its respective rights and remedies, under Schedule 2 (Data Protection).',
        },
      ],
      prefix: '16',
    },
  ],
};
